/**
 * 任務追蹤共用樣式與小工具
 */
export const C = {
  brand: '#7b4f2f',
  brandDark: '#5e3a1a',
  brandSoft: '#f7efe8',
  border: '#e5e7eb',
  muted: '#6b7280',
  danger: '#b91c1c',
  ok: '#166534',
  star: '#f59e0b',
};

export const btn = {
  padding: '6px 12px',
  border: `1px solid ${C.brandDark}`,
  borderRadius: 6,
  background: C.brand,
  color: '#fff',
  cursor: 'pointer',
  fontSize: 13,
  fontWeight: 600,
  whiteSpace: 'nowrap',
};
export const btnGhost = { ...btn, background: '#f3f4f6', color: '#1f2937', border: '1px solid #9ca3af' };
export const btnDanger = { ...btnGhost, color: C.danger, borderColor: '#fca5a5' };
export const btnSm = { padding: '3px 8px', fontSize: 12 };
export const btnLink = {
  border: 'none', background: 'transparent', color: C.brand, cursor: 'pointer', padding: 0, fontSize: 12, fontWeight: 600,
};
export const input = {
  padding: '5px 8px', border: '1px solid #ccc', borderRadius: 4, fontSize: 13, boxSizing: 'border-box', fontFamily: 'inherit',
};
export const select = { ...input, minWidth: 90, background: '#fff' };
export const card = {
  border: `1px solid ${C.border}`, borderRadius: 8, padding: 12, background: '#fff',
};
export const labelStyle = { fontSize: 12, color: C.muted, marginBottom: 3, display: 'block' };

export function todayYmd() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function addDays(ymd, n) {
  const d = new Date(`${ymd}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

export function diffDays(a, b) {
  return Math.round((Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`)) / 86400000);
}

export function fmtMD(ymd) {
  if (!ymd) return '';
  const [, m, d] = String(ymd).split('-');
  return `${Number(m)}/${Number(d)}`;
}

export function fmtDateTime(v) {
  if (!v) return '';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('zh-TW', {
    timeZone: 'Asia/Taipei', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false,
  });
}

export function statusOf(board, key) {
  const list = board?.statuses || [];
  return list.find((s) => s.key === key) || { key, label: key || '—', color: '#6b7280', isDone: false };
}

export function dueInfo(task, today, board) {
  if (!task.dueDate) return { text: '—', color: C.muted };
  const done = statusOf(board, task.status).isDone;
  const dd = diffDays(today, task.dueDate);
  if (done) return { text: fmtMD(task.dueDate), color: C.muted };
  if (dd < 0) return { text: `${fmtMD(task.dueDate)}（逾期 ${-dd} 天）`, color: C.danger };
  if (dd === 0) return { text: `${fmtMD(task.dueDate)}（今天）`, color: '#d97706' };
  return { text: fmtMD(task.dueDate), color: '#1f2937' };
}

export function fmtSize(n) {
  if (n == null) return '';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

export function isImage(att) {
  return /^image\//.test(att?.mime || '') || /\.(jpe?g|png|gif|webp)$/i.test(att?.fileName || '');
}

/** 依 parentId 排出樹狀順序：[{ task, depth }] */
export function flattenTree(tasks, collapsed = new Set()) {
  const ids = new Set(tasks.map((t) => t.id));
  const children = new Map();
  const roots = [];
  for (const t of tasks) {
    if (t.parentId && ids.has(t.parentId)) {
      if (!children.has(t.parentId)) children.set(t.parentId, []);
      children.get(t.parentId).push(t);
    } else {
      roots.push(t);
    }
  }
  const out = [];
  const walk = (t, depth) => {
    const kids = children.get(t.id) || [];
    out.push({ task: t, depth, hasChildren: kids.length > 0 });
    if (collapsed.has(t.id)) return;
    kids.forEach((k) => walk(k, depth + 1));
  };
  roots.forEach((t) => walk(t, 0));
  return out;
}
